import React from "react";
import styles from "./styles.scss";
import { Modal } from "react-bootstrap";
import { modalService } from "./ModalService";
import { AuditButton } from "components/AuditButton";
import { FormattedMessage } from "react-intl";

export const MODAL_SIZE = {
  STANDAR: "standar-dialog",
  MOREINFO: "moreinfo-dialog"
};

class EYModal extends React.Component {
  constructor(props) {
    super(props);

    // Default Modal options to be overwritten by user
    let defaultOptions = {
      title: "",
      body: "",
      buttons: [],
      onEnter: undefined,
      onEntering: undefined,
      onEntered: undefined,
      onExit: undefined,
      onExiting: undefined,
      onExited: undefined,
      show: false,
      size: undefined
    };
    this.state = { ...defaultOptions };
  }
  /* eslint-disable */

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!nextProps.size) {
      this.setState({ nextProps, size: MODAL_SIZE.STANDAR });
    }
  }
  /* eslint-enable */

  componentDidMount() {
    modalService._register(this);
  }

  componentWillUnmount() {
    modalService._unregister();
  }

  show(options) {
    options.title = options.title || this.state.title;
    options.show = true;
    this.setState({ ...this.state, ...options });
  }

  close() {
    this.setState({ ...this.state, show: false });
  }

  render() {
    const modalProps = {
      onEnter: this.state.onEnter,
      onEntering: this.state.onEntering,
      onEntered: this.state.onEntered,
      onExit: this.state.onExit,
      onExiting: this.state.onExiting,
      onExited: this.state.onExited,
      show: this.state.show
    };

    const { titleLabelId, bodyLabelId, buttons, size } = this.state;

    return (
      <Modal
        {...modalProps}
        dialogClassName={styles[size]}
        backdrop={"static"}
        backdropClassName={styles["modal-backdrop"]}
        keyboard={false}
      >
        <Modal.Header bsClass={styles["title-style"]} closeButton={false}>
          <Modal.Title componentClass={"h3"}>
            {titleLabelId && <FormattedMessage id={titleLabelId} />}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body bsClass={styles["body-style"]}>
          <div className="text">
            {bodyLabelId && <FormattedMessage id={bodyLabelId} />}
          </div>
        </Modal.Body>

        <Modal.Footer bsClass={styles["footer-style"]}>
          {buttons.map((button, index) => (
            <AuditButton
              onClick={button.callback}
              key={index}
              type={button.type}
              labelId={button.labelId}
              disabled={button.disabled}
            />
          ))}
        </Modal.Footer>
      </Modal>
    );
  }
}

export default EYModal;
